import React from 'react';
import styles from './messagingStatusParse.module.css';

export const messagingStatusSettings = {
  NO_OUTREACH: {
    label: 'Sem acionamento',
    description:
      'Ainda não tentamos falar com este cliente: nunca houve envio efetivo nem falha de disparo.',
  },
  NO_INTERACTION: {
    label: 'Sem interação',
    description:
      'Cliente incluído em uma campanha cuja mensagem ainda está pendente: não houve envio efetivo nem confirmação da operadora.',
  },
  NO_SEND_RECORDED: {
    label: 'Sem envio registrado',
    description: 'Nunca houve registro de campanha para este número.',
  },
  MESSAGE_RECEIVED: {
    label: 'Mensagem entregue',
    description: 'A última mensagem chegou ao celular do cliente, mas ainda não foi aberta.',
  },
  MESSAGE_READ: {
    label: 'Mensagem lida',
    description: 'A última mensagem foi aberta pelo cliente.',
  },
  MESSAGE_NOT_RECEIVED: {
    label: 'Mensagem não recebida',
    description:
      'A última mensagem não pôde ser entregue (número inválido, WhatsApp indisponível ou bloqueio).',
  },
  SEND_FAILED: {
    label: 'Falha no envio',
    description: 'A última tentativa de envio falhou por erro técnico ou da operadora.',
  },
  OPT_OUT: {
    color: '#B91C1C',
    backgroundColor: '#FEE2E2',
    label: 'Opt-out',
    description:
      'Cliente pediu para não receber mais mensagens. Qualquer registro de opt-out nesta empresa.',
  },
};

const defaultSettings = { label: '' };

const statusClassByValue = {
  NO_OUTREACH: styles.noOutreach,
  NO_INTERACTION: styles.noInteraction,
  NO_SEND_RECORDED: styles.noSendRecorded,
  MESSAGE_RECEIVED: styles.messageReceived,
  MESSAGE_READ: styles.messageRead,
  MESSAGE_NOT_RECEIVED: styles.messageNotReceived,
  SEND_FAILED: styles.sendFailed,
  OPT_OUT: styles.optOut,
};

const HIDDEN_FROM_SELECTOR = ['NO_SEND_RECORDED', 'NO_INTERACTION'];

export const messagingStatusOptions = Object.entries(messagingStatusSettings)
  .filter(([value]) => !HIDDEN_FROM_SELECTOR.includes(value))
  .map(([value, { label, description }]) => ({ value, label, description }));

export const translateMessagingStatus = (status) => {
  const settings = messagingStatusSettings[status] || defaultSettings;
  return settings.label;
};

const parseMessagingStatus = (status) => {
  const settings = messagingStatusSettings[status] || defaultSettings;
  const statusClass = statusClassByValue[status] || styles.noInteraction;

  return (
    <span className={`${styles.badge} ${statusClass}`}>
      {settings.label}
    </span>
  );
};

export default parseMessagingStatus;